import { ButtonHTMLAttributes, forwardRef } from 'react'

import SVGIcon from '@/components/base/svg-icon'
import Typography from '@/components/base/typography'
import TypographyMask from '@/components/base/typography-mask'

import { cn } from '@/lib/utils'

export type CloseButtonProps = ButtonHTMLAttributes<HTMLButtonElement>

const CloseButton = forwardRef<HTMLButtonElement, CloseButtonProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          // 'absolute right-[1.5rem] top-[1.5rem] z-10 lg:right-[3rem] lg:top-[3rem]',
          'group -m-[1rem] flex items-center space-x-[0.8rem] p-[1rem] font-gillsans uppercase text-copper',
          className
        )}
        {...props}
      >
        <TypographyMask>
          <Typography variant="label">{children}</Typography>
        </TypographyMask>
        <SVGIcon
          symbol="close-icon"
          className={cn(
            'h-[1rem] w-[1rem] fill-current group-hover:rotate-90',
            'transition-transform duration-500 ease-out-cubic'
          )}
        />
      </button>
    )
  }
)

export default CloseButton
